import { WizardComponentBaseProps } from "../../../../reusable_components/WizardPageController/WizardPageController.utils";
import { EngagementLetterWizardSharedData } from "../../CreateEngagementLetterWizard.utils";

export interface ClientSelectorProps
  extends WizardComponentBaseProps<EngagementLetterWizardSharedData> { }

export interface ClientTypeOption {
  id: string; // CODE
  label: string;
  checked: boolean;
}

export interface ClientPorterOption {
  id: number;
  label: string;
  checked: boolean;
}

export const debounce = (func: Function, delay: number) => {
  let timeoutId: NodeJS.Timeout;
  return (...args: any[]) => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

export const columnDefinitionForEngagementGrid = [
  {
    field: "ClientId",
    headerName: "Client Id",
    checkboxSelection: true,
    cellStyle: { borderRight: "0.5px solid lightgray" },
  },
  {
    field: "Client Name",
    headerName: "Client Name",
    cellStyle: { borderRight: "0.5px solid lightgray" },
  },
  {
    field: "Approval Status",
    headerName: "Approval Status",
    flex: 1,
    cellStyle: { borderRight: "0.5px solid lightgray" },
  },
  // {
  //   field: "CreatedBy",
  //   headerName: "Partner",
  //   flex: 1,
  //   cellStyle: { borderRight: "0.5px solid lightgray" },
  // },
  // {
  //   field: "CreatedDate",
  //   headerName: "Created On",
  //   flex: 1,
  //   cellRenderer: (props: any) =>
  //     dayjs(props.data.CreatedDate).format("MMM D, YYYY h:mm A"),
  //   cellStyle: { borderRight: "0.5px solid lightgray" },
  // },
];

// utils/gridUtils.ts

/**
 * Returns the matching row(s) in a list based on a pre-selected ID.
 *
 * @template row The row type
 * @param data List of rows to search through
 * @param idKey Key in the row object to match against
 * @param selectedId ID to find in the list
 * @returns Array of rows matching the selectedId (typically one or empty)
 */
export function getPreSelectedRows<row>(
  data: row[],
  idKey: keyof row,
  selectedId?: row[keyof row]
): row[] {
  if (!selectedId) return [];
  return data.filter((item) => item[idKey] === selectedId);
}

/**
 * Enforces single-row selection in a grid by preventing deselection
 * when only one row is selected and updating shared state accordingly.
 *
 * @param event Grid row selection event containing node and row data
 * @param prevIds Previously selected client IDs
 * @param setSharedData React state setter for shared selection data
 *
 * - If the user tries to deselect the last remaining row, it snaps back to selected.
 * - If a new row is selected, updates sharedData with the new clientMasterIds
 *   and selectedClientMasterId.
 */
export const enforceSingleSelection = (
  event: any,
  prevIds: number[] = [],
  setSharedData: React.Dispatch<React.SetStateAction<any>>
) => {
  const clientId = event.data?.ClientMasterId;
  if (!clientId) return;

  if (!event.node.isSelected() && prevIds.includes(clientId) && prevIds.length === 1) {
    event.node.setSelected(true);
    return;
  }

  if (event.node.isSelected()) {
    const alreadySelected = prevIds.length === 1 && prevIds[0] === clientId;
    if (alreadySelected) return;

    setSharedData((prev: any) => ({
      ...prev,
      clientMasterIds: [clientId],
      selectedClientMasterId: clientId,
    }));
  }
};